module.exports = __webpack_public_path__ + "img/21.12b93fc0.png";